module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-3.de93bef8.png";